const getAuthPrefix = (endpoint: string) => `/auth/${endpoint}`;
const getUserPrefix = (endpoint: string) => `/user/${endpoint}`;
const getClientPrefix = (endpoint: string) => `/client/${endpoint}`;
const getCompanyPrefix = (endpoint: string) => `/company/${endpoint}`;
const getLeadPrefix = (endpoint: string) => `/lead/${endpoint}`;
const getLotPrefix = (endpoint: string) => `/lot/${endpoint}`;
const getFavoritesPrefix = (endpoint: string) => `/favorites/${endpoint}`;
const getProjectPrefix = (endpoint: string) => `/project/${endpoint}`;
const getPlaceTypePrefix = (endpoint: string) => `/place_type/${endpoint}`;
const getNoticePrefix = (endpoint: string) => `/notice/${endpoint}`;
const getWebPushPrefix = (endpoint: string) => `/webpush/${endpoint}`;
const getMeetingPrefix = (endpoint: string) => `/meeting/${endpoint}`;
const getReservationPrefix = (endpoint: string) => `/reservation/${endpoint}`;
// TODO: Уточнить точную ручку
const getAppealsHistory = (endpoint: string) => `/appeals_history/${endpoint}`;
const getSubAgentPrefix = (endpoint: string) => `/sub_agent/${endpoint}`;
const getIntegrationDadataPrefix = (endpoint: string) => `/integration/dadata/${endpoint}`;
const getAgreementPrefix = (endpoint: string) => `/agreement/${endpoint}`;
const getAccreditationPrefix = (endpoint: string) => `/accreditation/${endpoint}`;
const getDaDataPrefix = (endpoint: string) => `/integration/dadata/${endpoint}`;
const getClientReassignmentPrefix = (endpoint = '') => `/client-reassignment${endpoint ? `/${endpoint}` : ''}`;
const getEmployeesPrefix = (endpoint: string) => `/employees/${endpoint}`;

export const ENDPOINTS = {
  auth: {
    login: getAuthPrefix('login'),
    register: getAuthPrefix('register'),
    registerEmployee: getAuthPrefix('register/employee'),
    companiesByInn: getAuthPrefix('companies/by-inn'),
    recovery: getAuthPrefix('recovery'),
    logout: getAuthPrefix('logout'),
    setPassword: getAuthPrefix('set_password'),
    // TODO: Проверить на реальном беке. Пока только согласован контракт
    phone: {
      sendCode: getAuthPrefix('phone/send_code'),
      login: getAuthPrefix('phone/login'),
    },
  },
  user: {
    current: getUserPrefix('current'),
    profile: getUserPrefix('profile'),
    create: getUserPrefix('create'),
    edit: getUserPrefix('edit'),
    changeDivision: getUserPrefix('change_division'),
    list: getUserPrefix('list'),
    get: (id: number) => getUserPrefix(`${id}`),
  },
  client: {
    leadList: getClientPrefix('lead_list'),
    get: (id: number) => getClientPrefix(`${id}`),
    create: getClientPrefix('create'),
    edit: getClientPrefix('edit'),
    unique: getClientPrefix('unique'),
    reassign: getClientPrefix('reassign'),
  },
  company: {
    create: '/company',
    list: getCompanyPrefix('list'),
    update: (id: number) => getCompanyPrefix(`${id}`),
  },
  employees: {
    registrationRequests: {
      list: getEmployeesPrefix('registration-requests'),
      approve: (id: number) => getEmployeesPrefix(`registration-requests/${id}/approve`),
      reject: (id: number) => getEmployeesPrefix(`registration-requests/${id}/reject`),
    },
  },
  dadata: {
    ids: getDaDataPrefix('ids'),
  },
  lead: {
    get: (id: number) => getLeadPrefix(`${id}`),
    list: getLeadPrefix('list'),
    create: getLeadPrefix('create'),
  },
  lot: {
    get: (id: number) => getLotPrefix(`${id}`),
    list: getLotPrefix('list'),
    filters: getLotPrefix('filters'),
    reservationInfo: (id: number) => getLotPrefix(`${id}/reservation_info`),
    reserve: (id: number) => getLotPrefix(`${id}/reserve`),
  },
  favorites: {
    create: getFavoritesPrefix('lot'),
    delete: (lotId: number) => getFavoritesPrefix(`lot/${lotId}`),
  },
  project: {
    list: getProjectPrefix('list'),
  },
  placeType: {
    list: getPlaceTypePrefix('list'),
  },
  notice: {
    list: getNoticePrefix('list'),
  },
  webPush: {
    getPublicKey: getWebPushPrefix('key'),
    subscribe: getWebPushPrefix('subscribe'),
    unsubscribe: getWebPushPrefix('unsubscribe'),
  },
  meeting: {
    get: (id: number) => getMeetingPrefix(`${id}`),
    list: getMeetingPrefix('list'),
    create: getMeetingPrefix('create'),
    edit: getMeetingPrefix('edit'),
    cancel: (id: number) => getMeetingPrefix(`cancel/${id}`),
    slots: getMeetingPrefix('slots'),
    update: (id: number) => getMeetingPrefix(`${id}`),
  },
  config: {
    get: () => '/config',
  },
  reservation: {
    list: getReservationPrefix('list'),
  },
  appealsHistory: {
    list: getAppealsHistory('list'),
  },
  subAgent: {
    list: getSubAgentPrefix('list'),
    create: getSubAgentPrefix('create'),
  },
  integrationDadata: {
    ids: getIntegrationDadataPrefix('ids'),
  },
  agreement: {
    registration: getAgreementPrefix('registration'),
  },
  accreditation: {
    get: '/accreditation',
    submit: getAccreditationPrefix('submit'),
  },
  clientReassignment: {
    create: getClientReassignmentPrefix(),
  },
};
